import React, { useContext, useEffect, useState } from "react";
// import Sidebar from '../StudentSidebar/Sidebar';
// import StudentNavbar from '../StudentNavbar/StudentNavbar';
import { Button } from "react-bootstrap";
import Vector from "../../assets/images/png/Vector.png";
import Image from "../../Components/Reusable/Image";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import { toast } from "react-toastify";
import { CirclesWithBar, RotatingLines } from "react-loader-spinner";
import parse from "html-react-parser";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import StudentNavbar from "../../StudentPanel/StudentNavbar/StudentNavbar";
import Sidebar from "../../StudentPanel/StudentSidebar/Sidebar";
import SessionManager from "../../Utils/Session";
import { AuthContext } from "../../Context/authContext";
import axios from "axios";
import { Modal } from "react-bootstrap";
const BharatSatTest = () => {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [durationInMinutes, setDurationInMinutes] = useState(0);
  // const [timeLeft, setTimeLeft] = useState(durationInMinutes * 60);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [subjectAnswers, setSubjectAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [subjectProgress, setSubjectProgress] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingTwo, setLoadingTwo] = useState(false);
  const [loading3, setLoading3] = useState(true);
  const [loading4, setLoading4] = useState(true);
  const [alldata, setAllData] = useState([]);
  const [subjectQuestionsById, setSubjectQuestionsById] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEarly, setIsModalOpenEarly] = useState(false);
  const [attemptedCount, setAttemptedCount] = useState(0);
  const [notAttemptedCount, setNotAttemptedCount] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [show, setShow] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);

  const instructions = [
    "Camera Visibility: Ensure your camera is on and you are clearly visible from head to chest throughout the examination.",
    "Fair Play: Maintain academic integrity. Do not engage in any form of cheating or malpractice.",
    "No Communication: Refrain from communicating with anyone during the examination.",
    "No External Assistance: Do not seek help from any external source, including textbooks, notes, or online resources.",
    "Time Management: The examination duration is 90 minutes. Allocate time wisely to answer all questions.",
    "Question Format: The examination consists of 100 Multiple Choice Questions (MCQs).",
    "Marking Scheme: Each correct answer carries 2 marks.",
    "Submission Deadline: The examination will be automatically submitted after 90 minutes. Ensure you submit your answers before the deadline.",
    "Result Implications: Any violation of the examination rules may lead to the cancellation of your result.",
    "The merit list will be prepared based on the marks obtained by the student and the time they took to complete the test.",
    "Each incorrect answer will result in a deduction of 0.5 marks from your total score. Please be mindful of this when answering the questions.",
  ];
  // Call this when starting the test

  // useEffect(() => {
  //     if (!startTime) return; // Ensure startTime is initialized

  //     const timerId = setInterval(() => {
  //         const currentTime = new Date();
  //         const elapsedTime = Math.floor((currentTime - startTime) / 1000); // Elapsed time in seconds
  //         const calculatedTimeLeft = durationInMinutes * 60 - elapsedTime;

  //         if (calculatedTimeLeft <= 0) {
  //             // Ensure timeLeft does not go negative
  //             setTimeLeft(0);
  //             clearInterval(timerId); // Stop further updates
  //             // handleSubmit(); // Trigger submission
  //         } else {
  //             setTimeLeft(calculatedTimeLeft);
  //         }
  //     }, 1000);

  //     return () => clearInterval(timerId); // Cleanup on unmount or dependency change
  // }, [startTime, durationInMinutes]);

  useEffect(() => {
    if (timeLeft === 0) {
      handleSubmit(); // Ensure submission logic executes exactly once
    }
  }, [timeLeft]);

  const convertToIST = (utcDate) => {
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds (5 hours 30 minutes)
    const istDate = new Date(utcDate.getTime() + istOffset); // Convert to IST
    return istDate;
  };

  const fetchCurrentTime = async () => {
    try {
      const response = await axios.get(
        "https://timeapi.io/api/Time/current/zone?timeZone=Etc/UTC"
      );

      // const data = await response.json();
      const fetchedDate = new Date(response.data.dateTime); // Return the current time as a Date object
      if (isNaN(fetchedDate)) {
        throw new Error("Invalid date fetched from API");
      }

      return convertToIST(fetchedDate);
    } catch (error) {
      console.error("Error fetching time:", error);
      return new Date(); // Fallback to local time if API fails
    }
  };
  useEffect(() => {
    fetchCurrentTime();

    // Check if button should be enabled
    const interval = setInterval(() => {
      fetchCurrentTime();
    }, 10000); // Update time every minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkExamStartTime = async () => {
      const currentTime = await fetchCurrentTime(); // Fetch the current time from the server
      if (!user.bharatSatExamDate) return; // Exit if no exam date is defined

      const examDate = new Date(user.bharatSatExamDate); // Create a Date object from bharatSatExamDate
      const examStartTime = new Date(user.examStartTime); // Parse examStartTime directly
      const examEndTime = new Date(user.examEndTime); // Parse examEndTime directly

      // Ensure the exam logic runs only on the exam date
      const isSameDate = currentTime.toDateString() === examDate.toDateString();
      const timeDifference = (examStartTime - currentTime) / 1000; // Time difference in seconds

      if (!isSameDate) {
        setLoading4(false);
        setShow(false);
        console.log("You’re Early. Please check the exam schedule for the correct date.");
        return;
      }

      // Show "You’re Early" message if the test is more than 15 minutes away
      if (timeDifference > 15 * 60) {
        setLoading4(false);
        setShow(false);
        console.log("You’re Early. The test will open 15 minutes before the scheduled time.");
        return;
      }

      // Show the modal if the exam is starting in 15 minutes or less
      if (timeDifference <= 15 * 60 && timeDifference > 0) {
        setLoading4(true);
        setShow(true);
      }

      // Handle the case where the test is in progress or can be started
      if (currentTime >= examStartTime && currentTime <= examEndTime) {
        setLoading3(true); // Set loading before API call
        try {
          const currentTime2 = new Date();
          setStartTime(currentTime2);
          await getAllBharaSatExamQuestionsById(user.bharatSatExamId); // Fetch questions
          setIsModalOpenEarly(false); // Close the early modal
          setShow(false);
          clearInterval(interval); // Stop interval once the test starts
        } finally {
          setLoading3(false);
          setLoading4(false); // Ensure loading is reset
        }
      } else {
        console.log("You cannot start the exam yet. Please check the exam schedule.");
      }
    };

    checkExamStartTime();

    // Set an interval to periodically check exam status
    const interval = setInterval(checkExamStartTime, 5000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [user.bharatSatExamId, user.examStartTime, user.examEndTime, user.bharatSatExamDate]);
  useEffect(() => {
    const updateRemainingTime = async () => {
      const currentTime = await fetchCurrentTime();
      const endTime = new Date(user.examEndTime);

      const remainingSeconds = Math.floor((endTime - currentTime) / 1000);
      if (remainingSeconds <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
      } else {
        setTimeLeft(remainingSeconds);
      }
    };

    updateRemainingTime(); // Initial call
    const interval = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(interval);
  }, [user.examEndTime]);

  const handleOpenModal = () => {
    const subData = {
      ...subjectProgress,
      [selectedSubjectId]: allQuestions,
    };

    setSubjectProgress(subData);

    const combinedQuestions = Object.values(subData).flat();

    // Map through combined questions and update answers for submission
    const updatedSubjectQuestionsById = subjectQuestionsById.map(
      (subjectQuestion) => {
        const correspondingUserQuestion = combinedQuestions.find(
          (q) => q.questionId === subjectQuestion.questionId
        );

        if (correspondingUserQuestion) {
          // For Comprehensive and Poem types
          if (
            subjectQuestion.type === "Comprehensive" ||
            subjectQuestion.type === "Poem"
          ) {
            const updatedSubQuestions = subjectQuestion.questions.map(
              (subQ) => {
                const userSubQuestion =
                  correspondingUserQuestion.questions.find(
                    (sq) => sq.questionId === subQ.questionId
                  );
                return {
                  ...subQ,
                  answer:
                    userSubQuestion?.answer !== null
                      ? userSubQuestion.answer
                      : null,
                  status:
                    userSubQuestion?.answer !== null ? "answered" : "skipped",
                };
              }
            );

            return { ...subjectQuestion, questions: updatedSubQuestions };
          }
          // For General type
          else if (subjectQuestion.type === "General") {
            return {
              ...subjectQuestion,
              answer:
                correspondingUserQuestion?.answer !== null
                  ? correspondingUserQuestion.answer
                  : null,
              status:
                correspondingUserQuestion?.answer !== null
                  ? "answered"
                  : "skipped",
            };
          }
        }

        return subjectQuestion; // Keep unchanged if no corresponding question
      }
    );

    // Prepare subject data for submission
    const subjectData = subjects.map((subject) => ({
      subjectId: subject.subjectId,
      numberOfQuestions: subject.numberOfQuestions,
    }));

    // Prepare submitted answers, including skipped ones (set as -1)
    const submittedAnswers = updatedSubjectQuestionsById.flatMap((question) => {
      if (question.type === "Comprehensive" || question.type === "Poem") {
        return question.questions.map((subQuestion) => ({
          question_id: question.questionId,
          sub_question_id: subQuestion.questionId,
          selectedOption:
            subQuestion.answer !== null
              ? subQuestion.options.indexOf(subQuestion.answer)
              : -1, // Mark as -1 if no answer
          typeOfQuestion: question.type,
        }));
      } else if (question.type === "General") {
        return {
          question_id: question.questionId,
          selectedOption:
            question.answer !== null
              ? question.options.indexOf(question.answer)
              : -1, // Mark as -1 if no answer
          typeOfQuestion: question.type,
        };
      }
      return [];
    });

    // Calculate submitted and not submitted counts from submittedAnswers
    const submittedCount = submittedAnswers.filter(
      (answer) => answer.selectedOption !== -1
    ).length;
    const notSubmittedCount = submittedAnswers.length - submittedCount;

    setAttemptedCount(submittedCount);
    setNotAttemptedCount(notSubmittedCount);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const handleConfirmSubmit = () => {
    setIsModalOpen(false);
    handleSubmit();
  };

  function setSubjectsDataToDisplay(subjectQuestions, subjects, subjectId) {
    const formattedQuestions = subjectQuestions
      .flatMap((subject) =>
        subject.questions.map((question) => {
          if (question.typeOfQuestion === "Comprehensive") {
            return {
              subjectId: subject.subjectId, // Add subjectId to each question
              type: "Comprehensive",
              questionId: question.questionId, // Include questionId
              paragraph: question.question,
              questions: question.subQuestions.map((subQuestion) => ({
                questionId: subQuestion.subQuestionId,
                question: subQuestion.question,
                options: subQuestion.options,
                answer: null,
                status: "unanswered",
              })),
            };
          } else if (question.typeOfQuestion === "Poem") {
            return {
              subjectId: subject.subjectId, // Add subjectId to each question
              type: "Poem",
              questionId: question.questionId, // Include questionId
              paragraph: question.question,
              questions: question.subQuestions.map((subQuestion) => ({
                questionId: subQuestion.subQuestionId,
                question: subQuestion.question,
                options: subQuestion.options,
                answer: null,
                status: "unanswered",
              })),
            };
          } else if (question.typeOfQuestion === "General") {
            return {
              subjectId: subject.subjectId, // Add subjectId to each question
              type: "General",
              questionId: question.questionId,
              question: question.question,
              options: question.options,
              answer: null,
              status: "unanswered",
            };
          } else {
            return null;
          }
        })
      )
      .filter((q) => q !== null);

    setSubjects(subjects);
    setSubjectQuestionsById(formattedQuestions);
    const filteredQuestions = formattedQuestions.filter(
      (question) => question.subjectId === subjectId
    );

    setAllQuestions(filteredQuestions);

    if (subjectId) {
      const existingAnswers = subjectAnswers[subjectId] || [];

      setAllQuestions((prevQuestions) =>
        prevQuestions.map((q) => {
          if (q.type === "Comprehensive" || q.type === "Poem") {
            const questionAnswers = existingAnswers.find(
              (a) => a.question_id === q.questionId
            );
            if (questionAnswers) {
              q.questions.forEach((subQ) => {
                const subQAnswer = questionAnswers.selectedOption.find(
                  (sa) => sa.subQuestion_id === subQ.questionId
                );
                if (subQAnswer) {
                  subQ.answer = subQ.options[subQAnswer.selectedOption];
                  subQ.status =
                    subQAnswer.selectedOption !== undefined
                      ? "answered"
                      : "skipped";
                }
              });
            }
          } else if (q.type === "General") {
            const questionAnswer = existingAnswers.find(
              (a) => a.question_id === q.questionId
            );
            if (questionAnswer) {
              q.answer = q.options[questionAnswer.selectedOption];
              q.status =
                questionAnswer.selectedOption !== undefined
                  ? "answered"
                  : "skipped";
            }
          }
          return q;
        })
      );
    }
  }

  const getAllBharaSatExamQuestionsById = async (
    encodedId,
    subjectId = null
  ) => {
    setLoading(true);
    try {
      const response =
        await StudentDashboardServices.getAllBharaSatExamQuestionsById(
          encodedId
        );

      setAllData(response.data);
      setDurationInMinutes(response.data.durationInMinutes);
      const { subjectQuestions, subjects } = response.data;
      var selectedSubjectDataId = subjectId;
      // If no subjectId is provided and there are subjects available, select the first subject as default
      if (subjectId === null && subjects.length > 0) {
        const defaultSubject = subjects[0];
        setSelectedSubjectId(defaultSubject.subjectId);
        setActiveTab(defaultSubject.subjectName);
        selectedSubjectDataId = defaultSubject.subjectId;
        // return getAllBharaSatExamQuestionsById(encodedId, defaultSubject.subjectId);
      }

      // Processing questions and formatting them
      setSubjectsDataToDisplay(
        subjectQuestions,
        subjects,
        selectedSubjectDataId
      );
    } catch (error) {
      handleApiErrors(error);
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubjectChange = (subjectId, subjectName) => {
    // Update the status of the current question before changing the subject
    const updatedQuestions = allQuestions.map((item, index) => {
      if (
        (item.type === "Comprehensive" || item.type === "Poem") &&
        index === currentQuestionIndex
      ) {
        const updatedSubQuestions = item.questions.map((subQuestion) => {
          if (
            subQuestion.status === "unanswered" &&
            subQuestion.answer == null
          ) {
            return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
          }
          return subQuestion;
        });
        return { ...item, questions: updatedSubQuestions };
      }
      if (
        index === currentQuestionIndex &&
        item.status === "unanswered" &&
        item.answer == null
      ) {
        return { ...item, status: "skipped" }; // Mark as skipped
      }
      return item;
    });

    // Save progress with updated questions before changing subject
    saveSubjectProgress(selectedSubjectId, updatedQuestions);

    if (subjectId === selectedSubjectId) {
      return; // Do not reset or change anything if it's the same subject
    }

    // Load saved progress or fetch new questions for the new subject
    const savedProgress = subjectProgress[subjectId];
    if (savedProgress) {
      setAllQuestions(savedProgress);
    } else {
      const { subjectQuestions, subjects } = alldata;

      setSubjectsDataToDisplay(subjectQuestions, subjects, subjectId);
      // getAllBharaSatExamQuestionsById(encodedId, subjectId);
    }
    // Merge the new subject progress with the existing subject progress
    const updatedSubjectProgress = {
      ...subjectProgress, // Keep the previous subjects' progress
      [selectedSubjectId]: updatedQuestions, // Add the current subject's progress before switching
    };
    setSubjectProgress(updatedSubjectProgress); // Update the subjectProgress state with the merged progress

    // Set the active tab and update other states
    setActiveTab(subjectName);
    setSelectedSubjectId(subjectId);
    setCurrentQuestionIndex(0);
  };

  // save the progress of the current subject
  const saveSubjectProgress = (subjectId, questions) => {
    setSubjectProgress((prevProgress) => ({
      ...prevProgress,
      [subjectId]: questions,
    }));
  };

  const handleSubmit = async () => {
    setLoadingTwo(true);
    try {
      const endTime = new Date().toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: true,
      });
      const startFormattedTime = startTime.toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: true,
      });
      const currentTime = new Date();
      const timeTakenInSeconds = Math.max(
        Math.floor((currentTime - startTime) / 1000),
        0
      ); // Time elapsed since exam started

      // const timeTakenInSeconds = Math.max(durationInMinutes * 60 - timeLeft, 0);
      const hours = Math.floor(timeTakenInSeconds / 3600);
      const minutes = Math.floor((timeTakenInSeconds % 3600) / 60);
      const seconds = timeTakenInSeconds % 60;

      const formattedTime = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      const submittedDate = new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: true,
      });
      // Save progress for the current subject
      // saveSubjectProgress(selectedSubjectId, allQuestions);
      // Combine all subjects' progress before submitting

      const subData = {
        ...subjectProgress,
        [selectedSubjectId]: allQuestions,
      };

      setSubjectProgress(subData);

      const combinedQuestions = Object.values(subData).flat();

      // Map through combined questions and update answers for submission
      const updatedSubjectQuestionsById = subjectQuestionsById.map(
        (subjectQuestion) => {
          const correspondingUserQuestion = combinedQuestions.find(
            (q) => q.questionId === subjectQuestion.questionId
          );

          if (correspondingUserQuestion) {
            // For Comprehensive and Poem types
            if (
              subjectQuestion.type === "Comprehensive" ||
              subjectQuestion.type === "Poem"
            ) {
              const updatedSubQuestions = subjectQuestion.questions.map(
                (subQ) => {
                  const userSubQuestion =
                    correspondingUserQuestion.questions.find(
                      (sq) => sq.questionId === subQ.questionId
                    );
                  return {
                    ...subQ,
                    answer:
                      userSubQuestion?.answer !== null
                        ? userSubQuestion.answer
                        : null,
                    status:
                      userSubQuestion?.answer !== null ? "answered" : "skipped",
                  };
                }
              );

              return { ...subjectQuestion, questions: updatedSubQuestions };
            }
            // For General type
            else if (subjectQuestion.type === "General") {
              return {
                ...subjectQuestion,
                answer:
                  correspondingUserQuestion?.answer !== null
                    ? correspondingUserQuestion.answer
                    : null,
                status:
                  correspondingUserQuestion?.answer !== null
                    ? "answered"
                    : "skipped",
              };
            }
          }

          return subjectQuestion; // Keep unchanged if no corresponding question
        }
      );

      // Prepare subject data for submission
      const subjectData = subjects.map((subject) => ({
        subjectId: subject.subjectId,
        numberOfQuestions: subject.numberOfQuestions,
        numberOfQuestionsBank: subject.numberOfQuestionsBank,
        numberOfQuestionsBharatSat: subject.numberOfQuestionsBharatSat,
      }));

      // Prepare submitted answers, including skipped ones (set as -1)
      const submittedAnswers = updatedSubjectQuestionsById.flatMap(
        (question) => {
          if (question.type === "Comprehensive" || question.type === "Poem") {
            return question.questions.map((subQuestion) => ({
              question_id: question.questionId,
              sub_question_id: subQuestion.questionId,
              selectedOption:
                subQuestion.answer !== null
                  ? subQuestion.options.indexOf(subQuestion.answer)
                  : -1, // Mark as -1 if no answer
              typeOfQuestion: question.type,
            }));
          } else if (question.type === "General") {
            return {
              question_id: question.questionId,
              selectedOption:
                question.answer !== null
                  ? question.options.indexOf(question.answer)
                  : -1, // Mark as -1 if no answer
              typeOfQuestion: question.type,
            };
          }
          return [];
        }
      );

      // Calculate submitted and not submitted counts from submittedAnswers
      // const submittedCount = submittedAnswers.filter(answer => answer.selectedOption !== -1).length;
      // const notSubmittedCount = submittedAnswers.length - submittedCount;
      // handleOpenModal(submittedCount, notSubmittedCount)
      // setIsModalOpen(true);
      // window.confirm(`Submitted Questions: ${submittedCount}\nNot Submitted Questions: ${notSubmittedCount}`);

      const response = await StudentDashboardServices.submitbharatSatExam(
        user.bharatSatExamId,
        user.eHallTicketId,
        formattedTime,
        submittedAnswers,
        subjectData,
        startFormattedTime,
        endTime,
        submittedDate
      );
      setLoadingTwo(false);
      toast.success(response.message);
      setIsSubmitted(true);
      // navigate(RoutesPath.mymocktest);
      // SessionManager.shared.logout();
    } catch (error) {
      setLoadingTwo(false);
      handleApiErrors(error);
      // toast.error("Failed to submit test. Please try again later.");
    }
  };

  const handleOptionChange = (
    questionIndex,
    option,
    subQuestionIndex = null
  ) => {
    setAllQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      const currentQuestion = updatedQuestions[questionIndex];

      if (
        (currentQuestion.type === "Comprehensive" ||
          currentQuestion.type === "Poem") &&
        subQuestionIndex !== null
      ) {
        const updatedSubQuestion = currentQuestion.questions[subQuestionIndex];
        updatedSubQuestion.answer =
          updatedSubQuestion.answer === option ? null : option;
        updatedSubQuestion.status =
          updatedSubQuestion.answer === null ? "skipped" : "answered";
        updatedQuestions[questionIndex].questions[subQuestionIndex] =
          updatedSubQuestion;
      } else {
        currentQuestion.answer =
          currentQuestion.answer === option ? null : option;
        currentQuestion.status =
          currentQuestion.answer === null ? "skipped" : "answered";
      }

      saveSubjectProgress(selectedSubjectId, updatedQuestions);
      return updatedQuestions;
    });
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return {
      hrs: String(hrs).padStart(2, "0"),
      mins: String(mins).padStart(2, "0"),
      secs: String(secs).padStart(2, "0"),
    };
  };

  const { hrs, mins, secs } = formatTime(timeLeft);

  const handleNextQuestion = () => {
    scrollToTop();
    // Update the status of the current question before moving to the next one
    const updatedQuestions = allQuestions.map((item, index) => {
      if (
        (item.type === "Comprehensive" || item.type === "Poem") &&
        index === currentQuestionIndex
      ) {
        const updatedSubQuestions = item.questions.map((subQuestion) => {
          if (
            subQuestion.status === "unanswered" &&
            subQuestion.answer == null
          ) {
            return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
          }
          return subQuestion;
        });
        return { ...item, questions: updatedSubQuestions };
      }
      if (
        index === currentQuestionIndex &&
        item.status === "unanswered" &&
        item.answer == null
      ) {
        return { ...item, status: "skipped" }; // Mark as skipped
      }
      return item;
    });

    setAllQuestions(updatedQuestions);

    // Move to the next question or subject
    if (currentQuestionIndex < allQuestions.length - 1) {
      setCurrentQuestionIndex((prevIndex) => {
        const newIndex = prevIndex + 1;
        return newIndex;
      });
    } else {
      const currentSubjectIndex = subjects.findIndex(
        (subject) => subject.subjectId === selectedSubjectId
      );
      const nextSubjectIndex = currentSubjectIndex + 1;

      if (nextSubjectIndex < subjects.length) {
        saveSubjectProgress(selectedSubjectId, updatedQuestions); // Save updated questions status
        const nextSubject = subjects[nextSubjectIndex];
        handleSubjectChange(nextSubject.subjectId, nextSubject.subjectName);
      } else {
        toast.info("You have completed all subjects.");
      }
    }
  };

  const handlePreviousQuestion = () => {
    scrollToTop();
    if (currentQuestionIndex > 0 || !isFirstQuestionOfSubject()) {
      const isFirstQuestion = currentQuestionIndex === 0;
      const isFirstSubject =
        subjects.length > 0 && selectedSubjectId === subjects[0].subjectId;

      if (isFirstQuestion && !isFirstSubject) {
        // Move to the previous subject
        const currentSubjectIndex = subjects.findIndex(
          (subject) => subject.subjectId === selectedSubjectId
        );
        if (currentSubjectIndex > 0) {
          const prevSubject = subjects[currentSubjectIndex - 1];
          handleSubjectChange(prevSubject.subjectId, prevSubject.subjectName);

          // Set to the last question of the previous subject
          const prevQuestions = subjectProgress[prevSubject.subjectId] || [];
          setCurrentQuestionIndex(prevQuestions.length - 1); // Move to the last question
        }
      } else {
        // Move to the previous question in the same subject
        const updatedQuestions = allQuestions.map((item, index) => {
          if (
            (item.type === "Comprehensive" || item.type === "Poem") &&
            index === currentQuestionIndex
          ) {
            const updatedSubQuestions = item.questions.map((subQuestion) => {
              if (
                subQuestion.status === "unanswered" &&
                subQuestion.answer == null
              ) {
                return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
              }
              return subQuestion;
            });
            return { ...item, questions: updatedSubQuestions };
          }

          if (
            index === currentQuestionIndex &&
            item.status === "unanswered" &&
            item.answer == null
          ) {
            return { ...item, status: "skipped" }; // Update the status to 'skipped'
          }

          return item;
        });
        setAllQuestions(updatedQuestions);
        setCurrentQuestionIndex((prevIndex) => {
          const newIndex = Math.max(prevIndex - 1, 0);

          return newIndex;
        });
      }
    }
  };
  const isFirstQuestionOfSubject = () => {
    return (
      currentQuestionIndex === 0 &&
      subjects.length > 0 &&
      selectedSubjectId === subjects[0].subjectId
    );
  };

  const isPreviousButtonDisabled = () => {
    const isFirstQuestion = currentQuestionIndex === 0;
    const isFirstSubject =
      subjects.length > 0 && selectedSubjectId === subjects[0]?.subjectId;
    const isLastSubjectFirstQuestion =
      subjects.length > 0 &&
      selectedSubjectId === subjects[subjects.length - 1].subjectId &&
      currentQuestionIndex === 0;

    return isFirstQuestion && isFirstSubject && !isLastSubjectFirstQuestion;
  };
  const handleQuestionBoxClick = (qIndex) => {
    // Only update the status if the selected question is different from the current question
    if (qIndex !== currentQuestionIndex) {
      // Update the status of the current question before moving to the selected one
      const updatedQuestions = allQuestions.map((item, index) => {
        if (
          (item.type === "Comprehensive" || item.type === "Poem") &&
          index === currentQuestionIndex
        ) {
          const updatedSubQuestions = item.questions.map((subQuestion) => {
            if (
              subQuestion.status === "unanswered" &&
              subQuestion.answer == null
            ) {
              return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
            }
            return subQuestion;
          });
          return { ...item, questions: updatedSubQuestions };
        }

        if (
          index === currentQuestionIndex &&
          item.status === "unanswered" &&
          item.answer == null
        ) {
          return { ...item, status: "skipped" }; // Mark as skipped
        }
        return item;
      });
      setAllQuestions(updatedQuestions);
    }

    // Set the current question index to the selected question box
    setCurrentQuestionIndex(qIndex);
  };

  const currentQuestion = allQuestions[currentQuestionIndex];

  const isComprehensiveAnswered = (question) => {
    return question.questions.every(
      (subQuestion) => subQuestion.answer !== null
    );
  };
  const isComprehensiveSkipped = (question) => {
    return question.questions.some(
      (subQuestion) => subQuestion.status === "skipped"
    );
  };
  const getAlphabetLabel = (index) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return letters[index] || "";
  };
  const decodeHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.documentElement.innerHTML;
  };
  const decodeHtmlopt = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };
  // useEffect(() => {
  //     const handleBeforeUnload = (e) => {
  //         e.preventDefault();
  //         e.returnValue = ''; // This triggers the confirmation dialog
  //     };

  //     window.addEventListener('beforeunload', handleBeforeUnload);

  //     return () => {
  //         window.removeEventListener('beforeunload', handleBeforeUnload); // Cleanup when component unmounts
  //     };
  // }, []);
  // useEffect(() => {
  //     // Push a new state to the browser history stack
  //     window.history.pushState(null, null, window.location.href);

  //     const handleBackButton = (e) => {
  //         // This will be called when the back button is pressed
  //         e.preventDefault();
  //         alert('Back button is disabled during the test.');
  //         // You can also push a new state to "cancel" the back action
  //         window.history.pushState(null, null, window.location.href);
  //     };

  //     window.addEventListener('popstate', handleBackButton);

  //     return () => {
  //         // Cleanup when the component unmounts
  //         window.removeEventListener('popstate', handleBackButton);
  //     };
  // }, []);

  const customParser = (node) => {
    if (node.name === "oembed") {
      const url = node.attribs.url;
      let videoId;
      // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
      if (url.includes("youtube.com")) {
        videoId = new URL(url).searchParams.get("v"); // Extract the video ID from the "v" parameter
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0]; // Extract the ID after the last "/"
      }
      if (videoId) {
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        );
      } else {
        return <p className="text-danger">Invalid YouTube URL</p>;
      }
    }
  };

  const cleanQuestionText = (text) => {
    return text
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  const getCurrentQuestionNumber = () => {
    // Get base number from previous subjects
    const baseNumber = subjects
      .slice(
        0,
        subjects.findIndex((s) => s.subjectId === selectedSubjectId)
      )
      .reduce((total, subject) => {
        const subjectQuestions = subjectQuestionsById.filter(
          (q) => q.subjectId === subject.subjectId
        );
        return (
          total +
          subjectQuestions.reduce((count, q) => {
            if (q.type === "Comprehensive" || q.type === "Poem") {
              return count + q.questions.length;
            }
            return count + 1;
          }, 0)
        );
      }, 0);

    // Count questions up to current index in current subject
    let currentSubjectCount = 0;
    const currentSubjectQuestions = allQuestions.slice(
      0,
      currentQuestionIndex + 1
    );

    for (let i = 0; i < currentSubjectQuestions.length - 1; i++) {
      const q = currentSubjectQuestions[i];
      if (q.type === "Comprehensive" || q.type === "Poem") {
        currentSubjectCount += q.questions.length;
      } else {
        currentSubjectCount += 1;
      }
    }

    // Add count for current question's previous sub-questions
    const currentQuestion =
      currentSubjectQuestions[currentSubjectQuestions.length - 1];
    if (
      currentQuestion?.type === "Comprehensive" ||
      currentQuestion?.type === "Poem"
    ) {
      currentSubjectCount += 1; // Add one for the current sub-question being displayed
    } else {
      currentSubjectCount += 1;
    }

    return baseNumber + currentSubjectCount;
  };

  const scrollToTop = () => {
    document.getElementById("scroll_bar").scroll(0, 0);
  };
  const handleStartTest = () => {
    setIsModalOpenEarly(true);
  };



  useEffect(() => {
    // const handleContextMenu = (e) => {
    //   e.preventDefault(); // Disable right-click context menu
    // };

    const handleKeyDown = (e) => {
      if (e.ctrlKey && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault(); // Disable Ctrl+C
      }
    };

    // window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      // window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  useEffect(() => {
    // Prevent Right Click
    const disableRightClick = (event) => event.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    // Prevent Screenshot & Developer Tools
    const disableShortcuts = (event) => {
        if (
            event.key === "PrintScreen" ||
            event.key === "F12" ||
            (event.ctrlKey && event.shiftKey && event.key === "I") || // DevTools
            (event.ctrlKey && event.key === "U") || // View Source
            (event.ctrlKey && event.shiftKey && event.key === "J")|| // Console
            (event.metaKey && event.shiftKey && event.key === "3") || // Mac Screenshot Cmd+Shift+3
            (event.metaKey && event.shiftKey && event.key === "4") || // Mac Screenshot Cmd+Shift+4
            (event.key === "Windows" && event.shiftKey && event.key === "S") // Disable Windows + Shift + S
        ) {
            event.preventDefault();
            alert("Screenshots and Developer Tools are disabled.");
        }
    };

    const clearClipboard = (event) => {
        if (event.key === "PrintScreen") {
            navigator.clipboard.writeText(""); // Clear clipboard
            alert("Screenshots are blocked.");
        }
    };

    document.addEventListener("keydown", disableShortcuts);
    document.addEventListener("keyup", clearClipboard);

    // Detect Screen Recording (Basic Attempt)
    const detectScreenRecording = () => {
        const videos = document.querySelectorAll("video");
        videos.forEach(video => {
            if (video.readyState >= 2) {
                video.pause();
                alert("Screen recording is not allowed!");
            }
        });
    };

    const screenCheckInterval = setInterval(detectScreenRecording, 1000);

    return () => {
        document.removeEventListener("contextmenu", disableRightClick);
        document.removeEventListener("keydown", disableShortcuts);
        document.removeEventListener("keyup", clearClipboard);
        clearInterval(screenCheckInterval);
    };
}, []);

  return (
    <div className="d-flex"onContextMenu={(e) => e.preventDefault()}>
      <Sidebar />
      <div className="mainLayout-content">
        <StudentNavbar />
        <div
          className="main_content contentSection scroll_bar bg-white"
          id="scroll_bar"
        >
          {show ? (
            <div className="border m-5">
              <div
                className="d-flex justify-content-between mb-3 align-items-center px-3 py-2"
                id="contained-modal-title-vcenter"
                style={{ backgroundColor: "#EFF5FF" }}
              >
                <h2 className="Heading headingColor text-center fw-600">
                  Instructions:
                </h2>
                <div className="medium-text fw-500 text-danger fst-italic">
                  Please read the instructions carefully before starting the
                  test.
                </div>
              </div>

              <Modal.Body>
                <div className="container-fluid ps-4">
                  {instructions.map((instruction, index) => (
                    <div key={index} className="mb-4">
                      <div className="mb-2 medium-text fw-600 d-flex">
                        <span className="fst-italic">{index + 1}. &nbsp;</span>
                        <em className="medium-text fw-400">{instruction}</em>
                      </div>
                    </div>
                  ))}
                </div>
              </Modal.Body>
              <Modal.Footer className="text-center border-0 d-flex justify-content-center">
                <div className=" my-4">
                  <SubmitButtonTwo
                    title={"Start Test"}
                    className="start-test-btn"
                    onclick={handleStartTest}
                  ></SubmitButtonTwo>
                </div>
              </Modal.Footer>
            </div>
          ) : loading3 && user?.examAttempted === false ? (
            <div className="no-records-container text-center" style={{ height: "calc(80vh - 5.2rem)" }}>
              {loading4 ? (
                // Show loader when the time is within 15 minutes
                <div className="text-center d-flex justify-content-center">
                  <CirclesWithBar
                    height="80"
                    width="80"
                    color="#F6821F"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                </div>) : (
                <div>
                  {user.examTimeOver === true ?
                    <p className='Small-Heading text-danger fw-700 mb-0' style={{ marginTop: '54px' }}>Time Is Over!</p> :
                    <p className='Small-Heading fw-700 mb-0' style={{ marginTop: '54px' }}>You’re Early</p>
                  }
                  <div className="no-record-image" style={{ backgroundColor: 'transparent', marginTop: '0px', width: "auto" }}>
                    <Image src={PngImages.earlyexamimage} className="img-fluid" />
                    {user.examTimeOver === true ? null : <p className='small-medium-text fw-700 mb-0' style={{ marginTop: '54px' }}>You cannot access the exam before the scheduled time.</p>}

                  </div>

                </div>
              )}
            </div>
          ) : isSubmitted || user?.examAttempted === true ? (
            <div className="text-center">
              <div className="no-record-image">
                <Image src={PngImages.examsubmitpic} className="img-fluid" />
              </div>
              {user?.examAttempted === true ? (
                <p
                  className="no-records-text Small-Heading fw-700 mb-4"
                  style={{ color: "#368C36" }}
                >
                  Your Exam Already Submitted Successfully!
                </p>
              ) : (
                <p
                  className="no-records-text Small-Heading fw-700 mb-4"
                  style={{ color: "#368C36" }}
                >
                  Exam Submitted Successfully!
                </p>
              )}

              <div className="d-flex justify-content-center">
                {user?.examAttempted === true ? (
                  ""
                ) : (
                  <p
                    className="no-records-text Small-Heading fw-700 mb-4"
                    style={{ color: "#368C36" }}
                  >
                    Now You can Close this Window!
                  </p>
                )}
              </div>
            </div>
          ) : (
            <div className="mb-3 justify-content-between align-items-center">
              <h1 className="black sub-large-text-one fw-700">
                {alldata.mockTestName}
              </h1>

              <div className="my-4 row">
                <div className="col-md-12 col-lg-7 col-xl-8 col-xxl-9 ">
                  <ul className="small-medium-text overflow-auto fw-600 list-group list-group-horizontal gap-1 mb-4 text-white">
                    {subjects.map((subject) => (
                      <li
                        key={subject.subjectId}
                        className={`list-group-item border-0 ${activeTab === subject.subjectName ? "active" : ""
                          }`}
                        onClick={() =>
                          handleSubjectChange(
                            subject.subjectId,
                            subject.subjectName
                          )
                        }
                        style={{
                          cursor: "pointer",
                          borderRadius: "6px",
                          backgroundColor:
                            activeTab === subject.subjectName
                              ? "#F6821F"
                              : "transparent",
                        }}
                      >
                        {subject.subjectName}
                      </li>
                    ))}
                  </ul>

                  <div
                    className="small-medium-text fw-600 hrline2"
                    style={{ color: "#14489F" }}
                  >
                    <p className="">Question {getCurrentQuestionNumber()}</p>
                  </div>

                  <section className="small-medium-text my-4">
                    {loading ? (
                      <div className="text-center d-flex justify-content-center">
                        <CirclesWithBar
                          height="80"
                          width="80"
                          color="#F6821F"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      <>
                        {(currentQuestion?.type === "Comprehensive" ||
                          currentQuestion?.type === "Poem") && (
                            <div>
                              {/* <div className="small-medium-text fw-600">
                                Read Carefully
                              </div> */}

                              {currentQuestion?.type === "Poem" ||
                                "Comprehensive" ? (
                                <div
                                  className="w-100 blog-data-html mt-2 fw-600"
                                  style={{ contain: "content" }}
                                >
                                  {cleanQuestionText(
                                    currentQuestion?.paragraph
                                  ) &&
                                    parse(
                                      cleanQuestionText(
                                        currentQuestion.paragraph
                                      ),
                                      { replace: customParser }
                                    )}
                                </div>
                              ) : null}
                              <div className="my-4 hrline2">
                                {currentQuestion?.questions?.map((q, index) => (
                                  <div key={index} className="my-4">
                                    <div className="small-medium-text fw-600 text-dark d-flex align-items-center gap-2 mb-3">
                                      <div style={{ marginBottom: "9px" }}>
                                        {index + 1}.{" "}
                                      </div>

                                      {currentQuestion?.type === "Poem" ||
                                        "Comprehensive" ? (
                                        <div
                                          className="w-100 blog-data-html mt-2"
                                          style={{ contain: "content" }}
                                        >
                                          {cleanQuestionText(q.question) &&
                                            parse(cleanQuestionText(q.question), {
                                              replace: customParser,
                                            })}
                                        </div>
                                      ) : null}
                                    </div>
                                    <ol className="list-group">
                                      {q.options?.map((option, optIndex) => (
                                        <li
                                          key={optIndex}
                                          className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                        >
                                          <div className="ms-2 me-auto form-check cursor-pointer">
                                            <input
                                              className="form-check-input border-2 "
                                              type="checkbox"
                                              style={{ boxShadow: "none" }}
                                              checked={q.answer === option}
                                              onChange={() =>
                                                handleOptionChange(
                                                  currentQuestionIndex,
                                                  option,
                                                  index
                                                )
                                              }
                                              id={`Comprehensive-option-${index}-${optIndex}`}
                                            />
                                            <label
                                              className="form-check-label small-medium-text fw-500 px-1 cursor-pointer"
                                              htmlFor={`Comprehensive-option-${index}-${optIndex}`}
                                            >
                                              <div className="d-flex gap-2">
                                                <span
                                                  style={{ marginTop: "2px" }}
                                                >
                                                  {getAlphabetLabel(optIndex)}.{" "}
                                                </span>{" "}
                                                <span>
                                                  {cleanQuestionText(option) &&
                                                    parse(
                                                      cleanQuestionText(option),
                                                      { replace: customParser }
                                                    )}
                                                </span>
                                              </div>
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    </ol>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                        {currentQuestion?.type === "General" && (
                          <div>
                            {currentQuestion?.type === "General" ? (
                              <div
                                className="w-100 small-medium-text fw-600 blog-data-html"
                                style={{ contain: "content" }}
                              >
                                {cleanQuestionText(currentQuestion?.question) &&
                                  parse(
                                    cleanQuestionText(currentQuestion.question),
                                    { replace: customParser }
                                  )}
                              </div>
                            ) : null}
                            <ol className="list-group mt-2 mb-4 hrline2">
                              {currentQuestion?.options?.map(
                                (option, optIndex) => (
                                  <li
                                    key={optIndex}
                                    className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                  >
                                    <div className="ms-2 me-auto form-check cursor-pointer">
                                      <input
                                        className="form-check-input border-2"
                                        type="checkbox"
                                        style={{ boxShadow: "none" }}
                                        checked={
                                          currentQuestion?.answer === option
                                        }
                                        onChange={() =>
                                          handleOptionChange(
                                            currentQuestionIndex,
                                            option
                                          )
                                        }
                                        id={`General-option-${optIndex}`}
                                      />
                                      <label
                                        className="form-check-label small-medium-text fw-500 px-1 cursor-pointer"
                                        htmlFor={`General-option-${optIndex}`}
                                      >
                                        <div className="d-flex gap-2">
                                          <span style={{ marginTop: "2px" }}>
                                            {getAlphabetLabel(optIndex)}.{" "}
                                          </span>{" "}
                                          <p>
                                            {cleanQuestionText(option) &&
                                              parse(cleanQuestionText(option), {
                                                replace: customParser,
                                              })}
                                          </p>
                                        </div>
                                      </label>
                                    </div>
                                  </li>
                                )
                              )}
                            </ol>
                          </div>
                        )}

                        <div className="d-flex flex-wrap justify-content-between align-items-center small-medium-text fw-400 px-2 gap-2">
                          <SubmitButtonTwo
                            title={"Previous"}
                            className="previewbtn"
                            onclick={handlePreviousQuestion}
                            disabled={isPreviousButtonDisabled()}
                          ></SubmitButtonTwo>
                          <div className="d-flex gap-3 ">
                            {!(
                              currentQuestionIndex ===
                              allQuestions.length - 1 &&
                              selectedSubjectId ===
                              subjects[subjects.length - 1].subjectId
                            ) && (
                                <SubmitButtonTwo
                                  className="nextbtn"
                                  title={"Next"}
                                  onclick={handleNextQuestion}
                                />
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </section>
                </div>

                <div
                  className="col-md-12 col-lg-5 col-xl-4 col-xxl-3"
                  style={{ backgroundColor: "#f3f5f6", borderRadius: "20px" }}
                >
                  <div
                    className="timerdiv medium-text fw-500 p-4 mx-2"
                    style={{ backgroundColor: "#14489F", borderRadius: "20px" }}
                  >
                    <p className="text-start respo-timelft align-items-center justify-content-center">
                      <Image
                        src={Vector}
                        alt="Timer Icon"
                        className="fw-500 pb-1 me-1"
                      />{" "}
                      Time Left
                    </p>
                    <div className="d-flex gap-3 respo-timelft justify-content-start text-start gap-3">
                      <div className="hours">
                        <span className="medium-text fw-600">{hrs}</span>
                        <div className="medium-text fw-400 pt-3">Hours</div>
                      </div>
                      <div className="minutes">
                        <span className="medium-text fw-600">{mins}</span>
                        <div className="medium-text fw-400 pt-3">Minutes</div>
                      </div>
                      <div className="seconds">
                        <span className="medium-text fw-600">{secs}</span>
                        <div className="medium-text fw-400 pt-3">Seconds</div>
                      </div>
                    </div>
                  </div>

                  <div className="questions-container hrline2 pb-4">
                    {(() => {
                      // Calculate the starting number based on questions in previous subjects
                      const startingNumber = subjects
                        .slice(
                          0,
                          subjects.findIndex(
                            (s) => s.subjectId === selectedSubjectId
                          )
                        )
                        .reduce((total, subject) => {
                          // Find questions for this subject
                          const subjectQuestions = subjectQuestionsById.filter(
                            (q) => q.subjectId === subject.subjectId
                          );

                          // Count total questions (including subquestions)
                          return (
                            total +
                            subjectQuestions.reduce((count, q) => {
                              if (
                                q.type === "Comprehensive" ||
                                q.type === "Poem"
                              ) {
                                return count + q.questions.length; // Count subquestions
                              }
                              return count + 1; // Count general question
                            }, 0)
                          );
                        }, 1); // Start from 1

                      let questionNumber = startingNumber; // Initialize counter with calculated starting number

                      return allQuestions
                        .filter(
                          (question) => question.subjectId === selectedSubjectId
                        )
                        .map((question, qIndex) => {
                          if (
                            question.type === "Comprehensive" ||
                            question.type === "Poem"
                          ) {
                            return (
                              <React.Fragment key={qIndex}>
                                {question.questions.map(
                                  (subQuestion, subIndex) => (
                                    <div
                                      key={`${qIndex}-${subIndex}`}
                                      className={`question-box ${subQuestion.answer
                                          ? "bg-green"
                                          : subQuestion.status === "skipped"
                                            ? "bg-yellow"
                                            : "bg-grey"
                                        }`}
                                      onClick={() =>
                                        handleQuestionBoxClick(qIndex)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {questionNumber++}
                                    </div>
                                  )
                                )}
                              </React.Fragment>
                            );
                          } else {
                            // For General questions
                            return (
                              <div
                                key={qIndex}
                                className={`question-box ${question.status === "answered"
                                    ? "bg-green"
                                    : question.status === "skipped"
                                      ? "bg-yellow"
                                      : "bg-grey"
                                  }`}
                                onClick={() => handleQuestionBoxClick(qIndex)}
                                style={{ cursor: "pointer" }}
                              >
                                {questionNumber++}
                              </div>
                            );
                          }
                        });
                    })()}
                  </div>

                  <div className="container m-4 d-grid gap-3">
                    <div className="d-flex justify-content-start align-items-center gap-3 small-medium-text">
                      <span className="bg-green answercircle"></span>Answered
                    </div>
                    <div className="d-flex justify-content-start align-items-center gap-3 small-medium-text">
                      <span className="bg-yellow answercircle"></span>Not
                      Answered
                    </div>
                    <div className="d-flex justify-content-start align-items-center gap-3 small-medium-text">
                      <span className="bg-grey answercircle"></span>Not Viewed
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mb-4">
                    {loadingTwo ? (
                      <div className="text-center d-flex justify-content-center">
                        <RotatingLines
                          height="25"
                          width="25"
                          strokeColor="#F6821F"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      <SubmitButtonTwo
                        className="submitbtn"
                        title={"Submit Test"}
                        onclick={handleOpenModal}
                      />
                    )}
                  </div>
                  {isModalOpen && (
                    <div className="modal-overlay-custom">
                      <div className="modal-content-custom">
                        <div
                          className="modal-header p-0 mb-3 d-flex justify-content-end"
                          style={{ borderBottom: "none" }}
                        >
                          {/* <h2 className="medium-text fw-600  mb-0" style={{ fontStyle: 'italic', color: '#FF0000' }}>{title}</h2> */}
                          <Image
                            className="cursor-pointer "
                            src={PngImages.redcross}
                            style={{ aspectRatio: 1 }}
                            onClick={() => handleCloseModal(false)}
                          />
                        </div>
                        <div className="d-flex justify-content-between">
                          <h3 className="large-text fw-600">Are you sure?</h3>
                          <p className="blue fw-600 text-undeline-custom">
                            {hrs.toString().padStart(2, "0")} hr{" "}
                            {mins.toString().padStart(2, "0")} mins{" "}
                            {secs.toString().padStart(2, "0")} secs left
                          </p>
                        </div>
                        <div>
                          <div className="d-flex gap-1 align-items-center p-3 custom-modal-bg-green border-radius-10">
                            <div className="custom-modal-text-green small-medium-text fw-600">
                              No. of attempted questions :
                            </div>
                            <div className="small-medium-text custom-modal-text-green fw-600">
                              {attemptedCount}
                            </div>
                          </div>
                          <div className="d-flex mt-2 p-3 gap-1 align-items-center custom-modal-bg-red border-radius-10">
                            <div className="custom-modal-text-red small-medium-text fw-600">
                              Not attempted questions :
                            </div>
                            <div className="small-medium-text custom-modal-text-red fw-600">
                              {notAttemptedCount}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-2 mt-5 justify-content-center">
                          <SubmitButtonTwo
                            className="nobutton cursor-pointer custom-width-50"
                            title={"No"}
                            onclick={handleCloseModal}
                          />
                          <SubmitButtonTwo
                            className="yesbutton cursor-pointer custom-width-50"
                            title={"Yes"}
                            onclick={handleConfirmSubmit}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <Modal
            show={isModalOpenEarly}
            onHide={() => {
              setIsModalOpenEarly(false);
            }}
            centered
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName="p-0 bg-transparent border-0 shadow-none"
          >
            <div class="p-0 modal-body">
              <div class="w-100 d-flex flex-column">
                <div
                  class="modal-content clip_content align-items-center d-flex flex-column"
                  style={{ border: "0px", borderRadius: "30px" }}
                >
                  <div
                    class="modal_border_bottom_two "
                    style={{ backgroundColor: "rgb(255, 53, 53)" }}
                  ></div>
                  <div className=" text-center p-4 border-0">
                    <div className="d-flex gap-3 justify-content-center py-4">
                      <Image
                        src={SvgImages.early}
                        className="img-fluid"
                        style={{ width: "6%" }}
                      />
                      <p className="Heading fw-700 mb-0 text-danger">
                        {" "}
                        You’re Early
                      </p>
                    </div>
                    <div
                      className="no-record-image"
                      style={{
                        backgroundColor: "transparent",
                        marginTop: "0px",
                        width: "auto",
                      }}
                    >
                      <p className="Small-Heading fw-600">
                        The exam hasn’t started yet; kindly wait until the
                        scheduled time.
                      </p>
                    </div>
                    <div className="d-flex justify-content-center text-center mt-4">
                      <SubmitButtonTwo
                        className="yesbutton cursor-pointer"
                        title="OK"
                        onclick={() => setIsModalOpenEarly(false)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default BharatSatTest;
